/*
 * Auth
 * @author: Elton Jain
 *
 * Methods
 * - login
 * - logout
 * - getLoginStatus
 * - 
 */

// NOTE
// Should not make Login check on every page load
// Should not send auth data on every login, ie. keep logic for sign up and login separate
// 

define('Auth',[
    'jquery',
    'UI',
    'History'
    // 'cookie'
], function($, UI, History) {
    'use strict';

    var Auth = {
        redirect_url: null,
        $popLogin: $('#popupLogin'),
        $popOnboard: $('#popupOnboard'),

        init: function() {
            // Initialization
            // 
            require(['modules/auth/facebook'], function(FACEBOOK) {
                FACEBOOK.init();
            });

            if (!this.check()) {
                // Checking user auth with cookies
                // console.log('User is not logged in');

                require(['modules/auth/google'], function(GOOGLE) {
                        // Load their SDKs
                        GOOGLE.init();
                    }
                );
            }

            // this.setup();
            // return false;
            this.bindEvents();
        },

        checkLogin: function() {
            // Check if User is logged in
            // Check from Cookie

        },
        /**
         * [check Check if User is logged in]
         * @return {[bool]} [true or false]
         */
        check: function () {
            return window._gtap.data !== undefined && window._gtap.data.userData !== undefined && window._gtap.data.userData !== null;
        },
        /**
         * [getUser get Logged in User's details]
         * @return {[object|false]} Literal object, or false if not logged in
         */
        getUser: function() {
            // Get User from window obect
            if (this.check()) {
                return window._gtap.data.userData;
            }
            return false;
        },

        bindEvents: function() {
            // Bind DOM elements
            var base = this;

            // if(!FACEBOOK || !GOOGLEPLUS) {
            //     console.log('Auth libs not loaded');
            // }
            
            
            // 2 Mixpanel Events: Click, and Success
            // Click from here, Success from PostLogin

            require(['modules/auth/facebook'], function(FACEBOOK) {
                // setTimeout(function () {
                UI.$b.on('click', '.btn-login-facebook', function() {

                    var trigger_source = $(this).data('section'),
                        loginData = {
                            redirect_url: base.redirect_url,
                            trigger_source: trigger_source
                        };

                    FACEBOOK.doLogin(loginData);
                });
            });

            require(['modules/auth/google'], function(GOOGLE) {
                UI.$b.on('click', '.btn-login-googleplus', function() {

                    var trigger_source = $(this).data('section'),
                        loginData = {
                            redirect_url: base.redirect_url,
                            trigger_source: trigger_source
                        };

                    GOOGLE.doLogin(loginData);
                });
            });
        },

        setup: function() {

        },
        checkLoginRequired: function(options) {
            if (!this.check()) {
                this.showLoginPopup(true, options);
                return false;
            }
            return true;
        },
        /**
         * [showLoginPopup description]
         * @param  {bool} show    [show or hide popup]
         * @param  {object} options [may include: redirect_url, source]
         * @return nothing
         */
        showLoginPopup: function(show, options) {
            var base = this,
                options = options || {};
            if (options.redirect_url) {
                base.redirect_url = options.redirect_url;
            }
            if (show === false) {
                // base.$popLogin.fadeOut('fast');
                base.$popLogin.removeClass('open');
                History.popState();
                UI.noscroll(false);
            } else {
                base.$popLogin.addClass('open');
                UI.noscroll();
                History.pushState({
                    popupId: 'popupLogin',
                    url: window.location.href,
                    removeEl: false,
                    callback: function () {
                        UI.noscroll(false);
                        if(options.callback) {
                            options.callback();
                        }
                    }
                });
                // base.$popLogin.fadeIn('fast');
                require(['Mixpanel'], function(MixPanel) {
                    // MixPanel.hit('login_click', mixpanelData);
                    MixPanel.hit('open', {
                        target: 'login-popup',
                        source: options.source || ''
                    });
                });
            }
        },
        showOnboardPopup: function(show) {
            var base = this;
            if (show === false) {
                //UI.$b.off('touchmove');
                UI.noscroll(false);
                base.$popOnboard.removeClass('open');
            } else {

                //UI.$b.on('touchmove', function(e) {
                //  e.preventDefault();
                //});

                UI.noscroll();
                base.$popOnboard.addClass('open');
                History.pushState({
                    popupId: 'popupOnboard',
                    removeEl: false,
                    url: window.location.href,
                    callback: function () {
                        UI.noscroll(false);
                    }
                });
            }
        }
    };

    // Auth.init();

    return Auth;
});
